import React from "react";

import AuthCardLayout from "layouts/AuthCardLayout";

import LogoutContent from "components/authentication/LogoutContent";

const Logout = () => {
  return (
    <AuthCardLayout>
      <div className="text-center">
        <LogoutContent layout="card" titleTag="h3" />
      </div>
    </AuthCardLayout>
  );
};

export default Logout;
